import { useEffect } from 'react';
import { Modal, Box, Text } from '@nimbus-ds/components';
import { CreateArTaxRulesResponseDto } from '@tiendanube/common';
import { toStatusType } from 'App/rtk';
import CancelAndConfirmButtons from 'commons/components/CancelAndConfirmButtons';
import { useToastStatus } from 'commons/hooks';
import { useTranslationAccount } from 'domains/Account/hooks';
import { useDeleteArTaxRulesMutation } from 'domains/Invoices/invoicesApi';

interface DeleteConfirmationModalProps {
  onClose: () => void;
  itemDeleted: CreateArTaxRulesResponseDto;
  showDeleteModal: boolean;
}
function DeleteConfirmationModal({
  onClose,
  itemDeleted,
  showDeleteModal,
}: DeleteConfirmationModalProps) {
  const t = useTranslationAccount(
    'businessDataPage.taxesWithExceptions.modalDelete',
  );
  const [deleteTaxRule, { status: deleteTaxRuleStatus }] =
    useDeleteArTaxRulesMutation();

  const confirmDelete = () => {
    if (itemDeleted !== null) {
      deleteTaxRule({ id: itemDeleted.id });
    }
  };

  useToastStatus({
    status: toStatusType(deleteTaxRuleStatus),
    success: t('textSuccess'),
    error: t('textError'),
    onSuccess: () => onClose(),
  });

  useEffect(() => {
    if (deleteTaxRuleStatus === 'fulfilled' && showDeleteModal) {
      onClose();
    }
  }, [deleteTaxRuleStatus, showDeleteModal, onClose]);

  return (
    <Modal open onDismiss={onClose}>
      <Modal.Header title={t('title')} />
      <Modal.Body padding="none">
        <Box paddingTop="4">
          <Text>{t('description')}</Text>
        </Box>
      </Modal.Body>
      <Modal.Footer>
        <CancelAndConfirmButtons
          isLoading={deleteTaxRuleStatus === 'pending'}
          isCancelDisabled={deleteTaxRuleStatus === 'pending'}
          confirmText={t('confirm')}
          onCancel={onClose}
          onConfirm={confirmDelete}
        />
      </Modal.Footer>
    </Modal>
  );
}

export default DeleteConfirmationModal;
